import axios from "axios";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;

async function getBlockedScript(payload) {
    const result = await axios.post(apiUrl + "/admin/getallowblockscripts",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getAddBlockedScript(payload) {
    const result = await axios.post(apiUrl + "/admin/blockscript",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

async function getUnblock(payload) {
    const result = await axios.post(apiUrl + "/admin/unblockscript",payload,{
         headers: jsonHeader}
    );
    return result.data || [];
}

export const ScriptBlockAllowServices = {
    getBlockedScript,
    getAddBlockedScript,
    getUnblock,
    
}